var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function range(start, end) {
    var counter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                counter = start;
                _a.label = 1;
            case 1:
                if (!(counter <= end)) return [3 /*break*/, 3];
                return [4 /*yield*/, counter++];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
export function capitalize(word) {
    return word[0].toUpperCase() + word.slice(1);
}
export function isMobileDevice() {
    return ((!!navigator.maxTouchPoints ||
        'ontouchstart' in document.documentElement) &&
        /android|iPad|iPhone|iPod/i.test(navigator.userAgent));
}
export function isAspectWithinRange(desiredAspect, currentAspect) {
    var diff = Math.abs(desiredAspect - currentAspect);
    var threshold = 0.05;
    return diff <= threshold;
}
export function filterInputValue(event, setQuery) {
    if (event.nativeEvent instanceof InputEvent) {
        var inputSymbol = event.nativeEvent.data;
        var pattern = /^[^\\*()?[\]]$/; // test symbols: \ * ( ) ? [ ]
        if (inputSymbol !== null) {
            if (pattern.test(inputSymbol))
                setQuery(event.target.value);
        }
        else {
            setQuery(event.target.value);
        }
    }
}
